import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import { SupplementaryInfoModel } from "../../../apis/ApisSupplementaryInformation";

export type SupplementaryInfoTableProps = {
    sppInfos: SupplementaryInfoModel[]
}

export function SupplementaryInfoTable(props: SupplementaryInfoTableProps) {
    const app = useContext(AppContext);

    return (<>
        {props?.sppInfos != null && props?.sppInfos.map(si => {
            return suppInfoCard(si);
        })}
    </>);
}

const suppInfoCard = (props: SupplementaryInfoModel) => {
    var appList = props.Applications.map(x => x.toString()).join(",");

    return (<div className="card card-body shadow mb-2" key={`SICard_${props.SupplementaryInfoId}`}>
        <div className="pb-1 d-flex"><h5 className="text-secondary-or-contrast">Added supplementary info</h5></div>
        <div className="d-flex flex-column">
            {positionRow("fa-calendar-days", "Date added", props.DateAdded)}
            {positionRow("fa-hashtag", "Reference", appList)}
            <p className="show-new-line py-1">
                {props.Body}
            </p>
        </div>
    </div>);
}

const positionRow = (iconClass: string, title: string, details: string) => {
    return (<div className="pb-1 d-flex"><div className="w-50 text-alt-or-contrast"><i className={`fa-solid ${iconClass} me-1`}></i><b>{title}:</b> </div><div className="w-50">{details}</div></div>);
}